import { capitalize } from 'lodash-es'

import { ContactV2Response } from '@/features/bookings/types/MasterData'

export const formatContactLabel = (contact?: ContactV2Response) => {
  if (!contact) {
    return
  }

  if (contact.firstName == null || contact.lastName == null) {
    return contact.email
  }

  return `${contact.firstName} ${contact.lastName}`
}

export const formatPricingLineItemUnit = (value: number, unit: string) => {
  return `${value} ${capitalize(unit)}${value !== 1 ? 's' : ''}`
}
